{
  "app": {
    "name": "HuntManager"
  },
  "auth": {
    "actionHandler": {
      "recoverEmail": {
        "advisoryAction": "You can do this either after logging in on your account information page, or you can request",
        "advisoryMessage": "If you reset your email address because someone else made this change, you should urgently also change your password.",
        "advisoryOr": "or contact",
        "advisoryResetLink": "a password reset link here",
        "invalidContact": "If you no longer have access to your account because someone changed your email address without your consent, please contact",
        "invalidMessage": "The email recovery code is invalid. It may have expired or already been used.",
        "invalidTitle": "Invalid code",
        "successMessage": "Your email address has been successfully restored to",
        "title": "Email address restored"
      },
      "resetPassword": {
        "accountHint": "You are resetting the password for:",
        "confirmPassword": "Confirm password",
        "invalidCode": "The password reset code is invalid. It may have expired or already been used.",
        "newPassword": "New password",
        "requestNewCode": "Request a new code here",
        "submit": "Change password",
        "submitError": "Failed to reset password. Please try again.",
        "title": "Set new password"
      },
      "title": "Processing action",
      "verifyEmail": {
        "continue": "Continue",
        "invalidMessage": "The email verification code is invalid. It may have expired or already been used.",
        "invalidRequestLink": "here",
        "invalidRequestNew": "If you still need to verify your email address, please request a new code:",
        "invalidTitle": "Invalid code",
        "successMessage": "Your email address has been successfully verified. You now have access to all portal features.",
        "title": "Email address verified"
      },
      "verifying": "Verifying code …"
    },
    "login": {
      "createAccount": {
        "prefix": "Don't have an account?",
        "postfix": "Sign up"
      },
      "email": "Email",
      "forgotPassword": "Forgot password?",
      "password": "Password",
      "submit": "Sign in",
      "title": "Sign in to your account"
    },
    "register": {
      "alreadyHaveAccount": {
        "prefix": "Already have an account?",
        "postfix": "Log in"
      },
      "confirmPassword": "Confirm password",
      "email": "Email",
      "firstName": "First name",
      "lastName": "Last name",
      "password": "Password",
      "submit": "Register",
      "title": "Create your account"
    },
    "resetPassword": {
      "backToLogin": "Back to login",
      "email": "Email",
      "emailSent": "Email has been sent. Please check your inbox.",
      "submit": "Send link",
      "subtitle": "We will send you a link via email",
      "title": "Reset password"
    }
  },
  "calendar": {
    "noEvents": "No events.",
    "noEventsOnDate": "No events on this day.",
    "selectEvent": "Select an event to view details.",
    "goToToday": "Today",
    "search": {
      "placeholder": "Search events…"
    },
    "event": {
      "create": "New event",
      "edit": "Edit event",
      "delete": "Delete event",
      "wholeDay": "All day",
      "rsvp": "Your response",
      "confirm": "Accept",
      "reject": "Decline",
      "awaitingResponse": "Response pending"
    },
    "dialog": {
      "createTitle": "New event",
      "editTitle": "Edit event"
    },
    "fields": {
      "title": "Title",
      "titlePlaceholder": "Event title",
      "begin": "Start date",
      "beginTime": "Start time",
      "end": "End date",
      "endTime": "End time",
      "wholeDay": "All day",
      "location": "Location",
      "contact": "Contact",
      "notice": "Notes",
      "color": "Color",
      "attendees": "Attendees"
    },
    "attendees": {
      "add": "Add attendee…",
      "remove": "Remove attendee"
    },
    "validation": {
      "titleRequired": "A title is required.",
      "endBeforeBegin": "The end time must be after the start time."
    }
  },
  "cameras": {
    "add": "Add camera",
    "back": "Back",
    "collections": "Collections",
    "details": {
      "aiSuggestion": {
        "accept": "Accept suggestion",
        "reject": "Reject suggestion",
        "suggested": "AI suggestion",
        "toggleBoundingBoxes": "Toggle detection boxes",
        "detected": "AI detection",
        "untrackedHint": "This classification is not tracked as a tag"
      },
      "chooseInterval": "Choose interval",
      "generatedAt": "Statistics generated on",
      "images": "Captures",
      "intervals": {
        "24h": "24 hours",
        "7d": "7 days"
      },
      "cancelSelection": "Cancel",
      "delete": "Delete",
      "deleteImage": "Delete image",
      "confirmDelete": "Delete image?",
      "deleting": "Deleting...",
      "loadMore": "Load more",
      "select": "Select",
      "selectImage": "Select image",
      "selected": "selected",
      "tag": "Tag",
      "viewImage": "View image",
      "nextInterval": "Next interval",
      "previousInterval": "Previous interval",
      "statistics": "Capture statistics",
      "subscription": {
        "subscribe": "Subscribe",
        "subscribed": "Subscribed",
        "tooltip": "Email updates for new photos"
      },
      "viewer": {
        "close": "Close",
        "previous": "Previous image",
        "next": "Next image",
        "delete": "Delete image",
        "share": "Share image",
        "linkCopied": "Link copied"
      },
      "moreSpecies": "More species",
      "note": "Note"
    },
    "dialog": {
      "title": "Add camera",
      "editTitle": "Edit camera",
      "edit": "Edit camera",
      "secacamId": "Secacam camera id",
      "note": "Note"
    },
    "filter": {
      "label": "Filter by species",
      "showMore": "Show {{count}} more species",
      "showLess": "Show fewer species",
      "clear": "Clear filter"
    },
    "images": "captures",
    "name": "Name",
    "noCameras": "No cameras available.",
    "noImages": "No captures available.",
    "allImages": "All captures",
    "status": {
      "online": "Online",
      "offline": "Offline",
      "unknown": "Status unknown",
      "power": {
        "cable": "Mains-powered",
        "battery": "Battery-powered",
        "unknown": "Power source unknown"
      }
    },
    "video": {
      "request": "Request video",
      "play": "Play video",
      "showPhoto": "Show photo",
      "requested": "Video requested",
      "requestedAgo": "Requested: {{time}}",
      "requestedHint": "The camera uploads the video with its next connection. This can take up to a day.",
      "noPermission": "Your Secacam account may not request videos for this camera.",
      "noCredits": "No video credits left for this camera, so no more videos can be requested right now.",
      "lowWarning": "Only a few video credits are left for this camera.",
      "requestFailed": "Video request failed: {{reason}}",
      "badge": {
        "requestable": "Video can be requested",
        "requested": "Video requested",
        "available": "Video available"
      },
      "filter": {
        "label": "Filter by video",
        "requested": "Requested",
        "available": "Available"
      },
      "confirm": {
        "title": "Request video?",
        "text": "Requesting this video uses up one video credit of your Secacam account.",
        "delay": "The camera uploads the video with its next connection, which can take up to a day.",
        "action": "Request video"
      },
      "quota": {
        "unlimited": "Unlimited video credits",
        "remaining": "{{remaining}} of {{total}} video credits left"
      }
    },
    "videos": "Videos",
    "noVideos": "No videos yet."
  },
  "common": {
    "all": "All",
    "back": "Back",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "comingSoon": "Coming soon",
    "create": "Create",
    "delete": "Delete",
    "edit": "Edit",
    "loadError": "Error loading: {{error}}",
    "logout": "Log out",
    "members": "Members",
    "ok": "OK",
    "profile": "Profile",
    "retry": "Retry",
    "save": "Save",
    "togglePassword": "Show/hide password"
  },
  "config": {
    "language": {
      "de": "German",
      "description": "Choose the app language.",
      "en": "English",
      "title": "Language"
    },
    "theme": {
      "dark": "Dark",
      "description": "Choose the appearance of the app.",
      "light": "Light",
      "system": "System",
      "title": "Appearance"
    },
    "title": "Settings"
  },
  "confirmEmailBanner": {
    "message": "Email verification pending"
  },
  "directions": {
    "N": "North",
    "NO": "Northeast",
    "O": "East",
    "SO": "Southeast",
    "S": "South",
    "SW": "Southwest",
    "W": "West",
    "NW": "Northwest"
  },
  "errors": {
    "auth": {
      "emailAlreadyInUse": "An account with this email address already exists.",
      "invalidCredentials": "Invalid email or password.",
      "networkError": "Network error. Please check your connection and try again.",
      "requiresRecentLogin": "Please log in again to complete this action.",
      "tooManyRequests": "Too many attempts. Please try again later.",
      "userDisabled": "This account has been disabled.",
      "weakPassword": "The password is too weak."
    },
    "deleteAccountFailed": "Account could not be deleted",
    "emailVerificationFailed": "Verification email could not be sent",
    "loadFailed": "Loading failed",
    "loginFailed": "Login failed",
    "logoutFailed": "Logout failed",
    "noUserLoggedIn": "No user logged in",
    "passwordResetEmailFailed": "Error sending password reset email.",
    "registrationFailed": "Registration could not be completed.",
    "updateFailed": "Error updating",
    "generic": "An unknown error occurred.",
    "status": {
      "400": "Invalid request.",
      "403": "You do not have permission to perform this action.",
      "404": "The requested resource was not found.",
      "409": "Conflict: The action could not be completed.",
      "500": "Server error. Please try again later."
    },
    "codes": {
      "BAD_REQUEST": "Invalid request.",
      "HAS_DEPENDENTS": "Cannot be deleted — still in use by: {{items}}.",
      "NOT_FOUND": "The resource was not found.",
      "FORBIDDEN": "You do not have permission for this action.",
      "KEY_NOT_ALLOWED": "This key is not allowed.",
      "CODE_ALREADY_USED": "This code has already been used.",
      "NO_RECIPIENT": "No recipient specified.",
      "NO_TOKEN": "No token provided.",
      "VALIDATION_ERROR": "The input is invalid.",
      "INVALID_TOKEN": "Invalid token.",
      "TOKEN_EXPIRED": "Token expired. Please log in again.",
      "SERVER_ERROR": "Server error. Please try again later.",
      "INVALID_API_KEY": "Invalid API key.",
      "MISSING_ACTION_CODE": "Action code is missing.",
      "UNAUTHORIZED": "Unauthorized.",
      "NETWORK": "Network error. Please check your connection.",
      "UNKNOWN": "An unknown error occurred.",
      "SECACAM_VIDEO_NOT_RECORDED": "The camera did not record a video for this photo.",
      "SECACAM_VIDEO_ALREADY_REQUESTED": "This video has already been requested.",
      "SECACAM_CAMERA_NOT_MAPPED": "This camera is not linked to a Secacam camera yet.",
      "SECACAM_CAMERA_NOT_FOUND": "The linked Secacam camera could not be found.",
      "SECACAM_VIDEO_NO_CREDITS": "No video credits are left.",
      "SECACAM_CAMERA_OFFLINE": "The camera is offline right now. Please try again later.",
      "SECACAM_VIDEO_NO_PERMISSION": "Your Secacam account may not request videos for this camera.",
      "SECACAM_VIDEO_REQUEST_FAILED": "The request could not be sent to the camera. Please try again.",
      "SECACAM_UNAVAILABLE": "The camera service is not reachable right now. Please try again later.",
      "SECACAM_CAMERA_IDENT_UNKNOWN": "The camera could not be identified. Please check the linked camera."
    }
  },
  "game": {
    "add": "Add entry",
    "age": {
      "young": "Young",
      "adult": "Adult",
      "unknown": "Unknown"
    },
    "chart": {
      "bySpecies": "By species",
      "bySex": "By sex",
      "byAge": "By age",
      "clickToFilter": "Click on species for details"
    },
    "charts": "Statistics",
    "confirm": {
      "delete": "Really delete this entry?"
    },
    "delete": "Delete entry",
    "edit": "Edit entry",
    "export": "Export Excel",
    "fields": {
      "species": "Species",
      "sex": "Sex",
      "age": "Age",
      "date": "Date",
      "time": "Time",
      "hunter": "Hunter",
      "location": "Location",
      "comment": "Comment",
      "sample": "Trichinella test",
      "photos": "Photos",
      "addPhoto": "Add photo"
    },
    "huntingYear": "Hunting year",
    "noEntries": "No game entries available.",
    "sex": {
      "female": "Female",
      "male": "Male"
    },
    "species": {
      "badger": "Badger",
      "hare": "Hare",
      "redDeer": "Red deer",
      "redFox": "Red fox",
      "roeDeer": "Roe deer",
      "wildBoar": "Wild boar"
    },
    "table": {
      "age": "Age",
      "comment": "Comment",
      "date": "Date",
      "hunter": "Hunter",
      "location": "Location",
      "number": "No.",
      "sample": "Sample",
      "sex": "Sex",
      "species": "Species",
      "time": "Time"
    },
    "title": "Game Harvest",
    "viewPhotos": "View photos",
    "viewerClose": "Close viewer",
    "viewerPrev": "Previous image",
    "viewerNext": "Next image"
  },
  "header": {
    "menuOpen": "Open menu",
    "notifications": "Tasks and notifications",
    "selectHuntingGround": "Select hunting ground",
    "userAccount": "User account"
  },
  "hides": {
    "addImage": "Add image",
    "removeImage": "Remove image",
    "create": "Create hide",
    "directions": "Wind directions",
    "edit": "Edit hide",
    "filterByDirection": "Filter by wind direction",
    "focalPoint": {
      "hint": "Tap to set the visible area",
      "ariaLabel": "Set the visible area of the image. Use arrow keys to adjust."
    },
    "filterMode": {
      "all": "All must match",
      "any": "At least 1 must match"
    },
    "image": "Image",
    "name": "Name",
    "noHides": "No hunting hides available.",
    "type": "Type",
    "types": {
      "drivenHuntHide": "Driven hunt hide",
      "hide": "Enclosed hide",
      "mobileHide": "Mobile hide",
      "openHide": "Open hide",
      "scissorLadder": "Scissor ladder",
      "seatLadder": "Seat ladder",
      "treeLadder": "Tree ladder"
    }
  },
  "huntingGround": {
    "accept": "Accept",
    "createNew": "Create new hunting ground",
    "decline": "Decline",
    "incomingInvitations": "Invitations",
    "invitedBy": "Invited by {{name}}",
    "nameLabel": "Hunting ground name",
    "namePlaceholder": "e.g. North Forest",
    "newHuntingGround": "New hunting ground",
    "noHuntingGrounds1": "You are currently not registered as a member of any hunting ground.",
    "noHuntingGrounds2": "Create a new hunting ground or wait for an invitation.",
    "title": "Hunting grounds",
    "yourHuntingGrounds": "Your hunting grounds"
  },
  "invitation": {
    "title": "Accept invitation",
    "accepting": "Accepting invitation...",
    "success": "You have been successfully added to the hunting ground \"{{huntingGround}}\".",
    "error": "The invitation could not be accepted.",
    "expiredOrUsed": "The invitation link has expired or has already been used.",
    "toHuntingGround": "To hunting ground",
    "toHome": "To home"
  },
  "map": {
    "tags": {
      "label": "Tags",
      "addPlaceholder": "Add tag",
      "createPrefix": "Create",
      "removeChip": "Remove tag",
      "filterTitle": "Filter by tag",
      "clear": "Clear",
      "delete": "Delete tag",
      "noTags": "No tags yet. Add tags when editing a marker or polygon.",
      "deleteDialog": {
        "title": "Delete tag",
        "message": "This tag is still used by {{count}} feature(s). Deleting it will remove it from all of them. Continue?",
        "confirm": "Delete anyway"
      }
    },
    "marker": {
      "color": "Color",
      "create": "New marker",
      "edit": "Edit marker",
      "editPosition": "Edit position",
      "hide": "Hunting hide",
      "hideImageAlt": "Photo of the hunting hide",
      "name": "Name",
      "noHide": "None",
      "type": "Type",
      "types": {
        "baitSite": "Bait site",
        "camera": "Camera",
        "cameraSending": "Sending camera",
        "drivenHuntHide": "Driven hunt hide",
        "hide": "Enclosed hide",
        "ladder": "Tree ladder",
        "mobileHide": "Mobile hide",
        "new": "New marker",
        "openHide": "Open hide",
        "saltLick": "Salt lick",
        "scissorLadder": "Scissor ladder",
        "seatLadder": "Seat ladder",
        "tbd": "Pending",
        "trash": "Trash"
      }
    },
    "confirmMarker": "Confirm marker",
    "cancelMarker": "Cancel",
    "confirmPolygon": "Confirm polygon",
    "cancelPolygon": "Cancel",
    "mode": {
      "createPolygon": {
        "desktop": "Click to begin polygon",
        "mobile": "Tap to begin polygon"
      },
      "initialLoad": "Loading markers...",
      "markerConfirm": {
        "desktop": "Click map to reposition the marker",
        "mobile": "Move map to reposition the marker"
      },
      "placeMarker": {
        "desktop": "Click to place the new marker",
        "mobile": "Tap to place the new marker"
      },
      "polygonConfirm": {
        "desktop": "Click to add new points (double to remove)",
        "mobile": "Tap to add new points (double to remove)"
      },
      "requestRunning": "Request running...",
      "creatingBoundary": {
        "mobile": "Tap to begin drawing boundary",
        "desktop": "Click to begin drawing boundary"
      },
      "boundaryConfirm": {
        "mobile": "Tap to add points, confirm to save",
        "desktop": "Click to add points, confirm to save"
      },
      "selectParcels": {
        "mobile": "Tap parcels to select them",
        "desktop": "Click parcels to select them"
      },
      "parcelInfo": {
        "desktop": "Hover over a parcel to see details",
        "mobile": "Tap a parcel to see details"
      }
    },
    "config": {
      "drawBoundary": "Draw boundary",
      "editBoundary": "Edit boundary",
      "weatherLocationSaved": "Weather location saved",
      "boundarySaved": "Boundary saved"
    },
    "options": {
      "apply": "Apply",
      "border": "District borders",
      "contourLines": "Contour lines",
      "layers": "Layers",
      "markerTypes": "Marker types",
      "parcels": "Parcels",
      "parcelsZoomHint": "Zoom in further to load parcels",
      "polygons": "Polygons",
      "title": "Map options"
    },
    "polygon": {
      "area": "Area (ha)",
      "create": "Create polygon",
      "edit": "Edit polygon",
      "editShape": "Edit shape",
      "filled": "Filled",
      "flurstuecke": "Parcels",
      "name": "Name",
      "outline": "Outline",
      "perimeter": "Perimeter (m)",
      "title": "Polygon"
    },
    "addMarker": "Place marker",
    "createPolygon": "Draw polygon",
    "selectParcels": "Select parcels",
    "cancelSelection": "Cancel",
    "selection": {
      "confirm": "New polygon from selection",
      "disjointHint": "Selected parcels aren't adjacent — used the largest area."
    },
    "search": {
      "title": "Parcel search",
      "gemarkung": "District",
      "flur": "Field block",
      "zaehler": "Numerator",
      "nenner": "Denominator",
      "search": "Search",
      "noResults": "No parcels found",
      "close": "Close",
      "selectRow": "Show on map",
      "col": {
        "nummer": "Parcel number",
        "lage": "Location",
        "gemarkung": "District",
        "flur": "Field block",
        "zaehler": "Numerator",
        "nenner": "Denominator"
      }
    },
    "speedDial": {
      "expand": "Open actions",
      "collapse": "Close actions"
    },
    "parcelInfo": {
      "title": "Parcel info",
      "close": "Close",
      "flurstueck": "Parcel",
      "flur": "Field block",
      "gemarkung": "District",
      "gemeinde": "Municipality",
      "lage": "Location",
      "kennzeichen": "Identifier",
      "area": "Area",
      "areaComputed": "Area (calculated)",
      "perimeter": "Perimeter",
      "landUse": "Land use"
    }
  },
  "huntingSeasons": {
    "admin": {
      "stage": {
        "title": "Update hunting seasons",
        "subtitle": "Scrapes all 17 sources, computes a diff against live data, and creates a pending preview for review. The database is only updated after approval.",
        "action": "Update hunting seasons",
        "actionTooltip": "Scrape all sources and compute changes",
        "checkingPending": "Checking for a pending preview…",
        "noPending": "No pending preview. Click \"Update hunting seasons\" to create one.",
        "duration": "Duration: {{ms}} ms",
        "syncCreatedAt": "Created: {{date}}",
        "lastSynced": "Last synced: {{date}}"
      },
      "status": {
        "pending": "Pending",
        "applied": "Applied",
        "rejected": "Rejected",
        "superseded": "Superseded"
      },
      "counts": {
        "added": "Added",
        "updated": "Updated",
        "removed": "Removed",
        "unchanged": "Unchanged"
      },
      "sources": {
        "panelTitle": "{{count}} sources",
        "errorCount": "{{count}} error(s)",
        "scrapeErrorBanner": "{{count}} source(s) could not be processed.",
        "skippedRows": "{{count}} row(s) skipped",
        "columns": {
          "state": "State",
          "status": "Status",
          "rows": "Rows",
          "parsed": "Parsed",
          "error": "Error / Skipped"
        },
        "status": {
          "success": "Success",
          "error": "Error"
        }
      },
      "changes": {
        "panelTitle": "{{count}} change(s)",
        "noChanges": "No changes – all data is up to date.",
        "columns": {
          "type": "Type",
          "state": "State",
          "species": "Species",
          "before": "Before",
          "after": "After"
        },
        "type": {
          "added": "Added",
          "updated": "Updated",
          "removed": "Removed"
        }
      },
      "apply": {
        "action": "Write to database",
        "actionTooltip": "Persist all changes to the database",
        "confirmTitle": "Apply changes?",
        "confirmMessage": "Apply changes? Added: {{added}}, Updated: {{updated}}, Removed: {{removed}}",
        "success": "Changes have been successfully written to the database."
      },
      "reject": {
        "action": "Discard",
        "actionTooltip": "Discard this preview without applying it"
      },
      "errors": {
        "loadFailed": "Could not load pending preview.",
        "stageFailed": "Update failed.",
        "actionFailed": "Action failed. Please try again."
      }
    },
    "display": {
      "title": "Hunting Seasons",
      "stateLabel": "Federal state",
      "searchPlaceholder": "Search species",
      "mobileTextToggle": "Visual display",
      "columns": {
        "species": "Species",
        "class": "Class",
        "season": "Season"
      },
      "class": {
        "male": "Male",
        "female": "Female",
        "all": "All"
      },
      "status": {
        "protected": "Year-round protected",
        "yearRound": "Year-round open"
      },
      "periodJoiner": "and",
      "legend": {
        "open": "Hunting season",
        "closed": "Closed season"
      },
      "empty": "No hunting seasons found for the selected state.",
      "loading": "Loading hunting seasons…",
      "error": "Failed to load hunting seasons.",
      "retry": "Retry",
      "disclaimer": {
        "title": "Disclaimer",
        "text": "All information on hunting and closed seasons is provided without warranty. Data is sourced from publicly available aggregators and updated regularly. The legal texts of the federal states and the federal government are exclusively authoritative."
      },
      "seasonBar": {
        "label": {
          "jan": "Jan",
          "feb": "Feb",
          "mar": "Mar",
          "apr": "Apr",
          "may": "May",
          "jun": "Jun",
          "jul": "Jul",
          "aug": "Aug",
          "sep": "Sep",
          "oct": "Oct",
          "nov": "Nov",
          "dec": "Dec"
        }
      }
    }
  },
  "secacamAdmin": {
    "reset": {
      "title": "Reset camera import",
      "description": "Clears the stored import cursor. The next scheduled run (in about 5 minutes) will then re-fetch up to 5000 images from the last 24 hours.",
      "action": "Reset camera import",
      "actionTooltip": "Clear the import cursor so the next run does a catch-up import",
      "confirmTitle": "Reset camera import?",
      "confirmMessage": "The stored import cursor will be cleared. The next scheduled run (in about 5 minutes) will then re-fetch up to 5000 images from the last 24 hours.",
      "success": "Import cursor was reset. The next run will re-fetch the last 24 hours.",
      "error": "Reset failed. Please try again."
    },
    "config": {
      "title": "Import limits",
      "description": "Controls how far back the camera import looks and how many images it fetches per run at most.",
      "loading": "Loading current values …",
      "loadError": "Failed to load the current values.",
      "fields": {
        "maxLookbackHours": "Max. time window (hours)",
        "maxImages": "Max. images per run",
        "autoTagConfidenceThreshold": "AI auto-tag threshold",
        "skipNoDetectionImages": "Skip images without AI detection"
      },
      "hints": {
        "maxLookbackHours": "{{min}}–{{max}} hours",
        "maxImages": "{{min}}–{{max}} images",
        "autoTagConfidenceThreshold": "Images are only tagged automatically from this detection confidence ({{min}}–{{max}}) upwards",
        "skipNoDetectionImages": "Images on which the AI detected nothing or only birds are not imported. Other detected but untracked objects (e.g. cars) are still imported. Each camera's newest image is kept per import anyway and removed again once a later import brings newer images."
      },
      "errors": {
        "required": "Required.",
        "min": "Minimum: {{min}}",
        "max": "Maximum: {{max}}"
      },
      "action": "Save",
      "actionTooltip": "Save import limits",
      "saveSuccess": "Import limits were saved.",
      "saveError": "Save failed. Please try again."
    },
    "aiBackfill": {
      "title": "Re-evaluate AI classifications",
      "description": "Re-interprets every image's stored ZEISS payload with the current species mapping. Old images gain the new species (badger, raccoon, fox …) and the display-only detections (bird, unknown). The retired catch-all \"other\" tag is replaced with the species now recognised, or dropped where there is no raw AI data.",
      "action": "Re-evaluate",
      "actionTooltip": "Walks every camera image page by page",
      "confirmTitle": "Re-evaluate classifications?",
      "confirmMessage": "Every camera image is re-evaluated. Tags set to \"other\" are replaced or removed. This can take a few minutes.",
      "error": "The re-evaluation failed.",
      "progress": {
        "scanned": "Scanned",
        "suggestions": "Suggestions updated",
        "remapped": "Other replaced",
        "dropped": "Other removed"
      }
    }
  },
  "speciesTrackingAdmin": {
    "title": "Tracked species",
    "description": "Species toggled off here are no longer offered as a filter chip or a taggable option. Images already tagged with them keep that tag.",
    "loading": "Loading current values …",
    "loadError": "Failed to load the current values.",
    "toggleAriaLabel": "Track {{species}}",
    "action": "Save",
    "actionTooltip": "Save the tracked species",
    "saveSuccess": "The tracked species were saved.",
    "saveError": "Save failed. Please try again."
  },
  "dashboard": {
    "title": "Dashboard",
    "greeting": "Hello, {{name}}",
    "greetings": {
      "morning": "Good morning, {{name}}!",
      "afternoon": "Good afternoon, {{name}}!",
      "evening": "Good evening, {{name}}!",
      "night": "Good night, {{name}}!"
    },
    "noGrounds": {
      "title": "Welcome!",
      "message": "Create your first hunting ground or join an existing one.",
      "createAction": "Create hunting ground"
    },
    "widgets": {
      "greetingHero": "Greeting",
      "quickActions": "Quick Actions",
      "myGrounds": "My Hunting Grounds",
      "upcomingEvents": "Upcoming Events",
      "awaitingResponse": "Pending Invitations",
      "huntingSeasonSummary": {
        "title": "Hunting Seasons",
        "opening": "Opens",
        "closing": "Closes",
        "empty": "No hunting seasons open or close in the next 30 days."
      },
      "stockFeed": "Stock Activity",
      "myTasks": "My Tasks",
      "recentHarvest": "Recent Harvest",
      "cameraStrip": "Camera Images",
      "members": "Members",
      "hidesSummary": "Recommended Hides",
      "activityFeed": "Activity",
      "pendingInvitations": "Pending Invitations",
      "weather": {
        "label": "Weather",
        "noLocation": "No weather location configured for this ground."
      }
    },
    "quickActions": {
      "addHarvest": "Harvest",
      "addTask": "Task",
      "addStockMovement": "Stock movement"
    },
    "customize": {
      "title": "Customize dashboard",
      "tooltip": "Customize dashboard",
      "dragHandle": "Reorder"
    },
    "dragHandle": "Reorder widget",
    "noEvents": "No upcoming events",
    "noRsvpPending": "No pending invitations",
    "viewAll": "View all",
    "ground": {
      "noTasks": "No open tasks",
      "allTasks": "All tasks",
      "noHarvest": "No harvest entries yet",
      "allHarvest": "All harvest entries",
      "noImages": "No camera images",
      "allImages": "All images",
      "noMembers": "No members",
      "allHides": "All hides",
      "hidesCount": "{{count}} hides",
      "windDirection": "Wind direction: {{dir}}",
      "noWindData": "No weather data available.",
      "noMatchingHides": "No hides match the current wind direction.",
      "kpi": {
        "openTasks": "Tasks",
        "harvest": "Harvest",
        "cameras": "Cameras",
        "hides": "Hides"
      }
    },
    "feed": {
      "today": "Today",
      "yesterday": "Yesterday",
      "loadMore": "Load more",
      "messagePlaceholder": "Message to the hunting ground...",
      "sendTooltip": "Send message",
      "empty": "No activity yet",
      "loading": "Loading..."
    },
    "pendingInvitations": {
      "incomingTitle": "Incoming Invitations",
      "outgoingTitle": "Sent Invitations",
      "accept": "Accept",
      "decline": "Decline",
      "revoke": "Revoke",
      "empty": "No pending invitations",
      "invitedBy": "Invited by {{name}}"
    }
  },
  "nav": {
    "account": "Account",
    "administration": "Administration",
    "appearance": "Appearance",
    "bookings": "Bookings",
    "calendar": "Calendar",
    "cameraDetails": "Camera details",
    "cameraStream": "Image Stream",
    "cameras": "Cameras",
    "categories": "Categories",
    "configuration": "Configuration",
    "dashboard": "Dashboard",
    "gameHarvest": "Game harvest",
    "general": "General",
    "hides": "Hunting hides",
    "huntingGround": "Hunting ground",
    "huntingGroundOverview": "Overview",
    "huntingSeasons": "Hunting seasons",
    "locations": "Storage locations",
    "map": "Map",
    "portalAdmin": "Portal Admin",
    "reservations": "Reservations",
    "settings": "Settings",
    "stock": "Stock",
    "storage": "Storage",
    "tasks": "Tasks",
    "userManagement": "User management",
    "whatsNew": "What's new"
  },
  "stockCategory": {
    "deleteDialog": {
      "title": "Delete category?",
      "message": "This category still has stock items or reservations. Do you want to delete it anyway? All associated entries will be removed.",
      "confirm": "Delete anyway"
    },
    "deleteError": "Category could not be deleted."
  },
  "stockLocation": {
    "deleteDialog": {
      "title": "Delete location?",
      "message": "This location still has stock items or reservations. Do you want to delete it anyway? All associated entries will be removed.",
      "confirm": "Delete anyway"
    },
    "deleteError": "Location could not be deleted."
  },
  "stock": {
    "title": "Storage",
    "newBooking": "New booking",
    "reserve": "Reserve",
    "owner": "Owner",
    "sharedWith": "Shared",
    "noLocations": "No storage locations available. Create a location first.",
    "noCategories": "No categories available. Create a category first.",
    "inventory": {
      "title": "Inventory",
      "add": "Add to stock",
      "noItems": "No entries available.",
      "addFirst": "Create storage locations and categories first.",
      "search": "Search by location, category or species...",
      "noSearchResults": "No items found."
    },
    "transaction": {
      "title": "Bookings",
      "add": "New booking",
      "keepOpen": "Keep open",
      "noItems": "No bookings available.",
      "type": {
        "addition": "Addition",
        "removal": "Removal",
        "reservation": "Reservation",
        "fulfilled": "Fulfilled",
        "discarded": "Discarded"
      }
    },
    "location": {
      "title": "Storage locations",
      "add": "Create location",
      "edit": "Edit location",
      "noItems": "No storage locations available.",
      "share": "Share",
      "owner": "Owner",
      "sharedWith": "Shared with",
      "noShareableMembers": "No members found in your hunting grounds.",
      "searchMembers": "Search members",
      "permissionRead": "Read",
      "permissionWrite": "Write",
      "sharedWithCount": "Shared with {{ count }} person(s)"
    },
    "category": {
      "title": "Categories",
      "add": "Create category",
      "edit": "Edit category",
      "noItems": "No categories available.",
      "aggregate": "Aggregated",
      "addSpecies": "Add species...",
      "speciesHint": "Confirm entry with Enter or comma",
      "quantityType": {
        "label": "Quantity type",
        "integer": "Integer (e.g. pieces, packages)",
        "decimal": "Decimal (e.g. kg, litres)"
      }
    },
    "reservation": {
      "title": "Reservations",
      "add": "Reserve",
      "noItems": "No reservations available.",
      "fulfill": "Fulfill",
      "cancel": "Cancel",
      "status": {
        "pending": "Pending",
        "fulfilled": "Fulfilled",
        "cancelled": "Cancelled"
      }
    },
    "fields": {
      "name": "Name",
      "species": "Species",
      "unit": "Unit",
      "quantity": "Quantity",
      "location": "Location",
      "category": "Category",
      "date": "Date",
      "user": "User",
      "note": "Note",
      "type": "Booking type",
      "packagingDate": "Packaging date",
      "batch": "Batch"
    },
    "table": {
      "number": "#",
      "location": "Location",
      "category": "Category",
      "species": "Species",
      "quantity": "Quantity",
      "unit": "Unit",
      "date": "Date",
      "user": "User",
      "type": "Booking type",
      "status": "Status",
      "note": "Note"
    },
    "validation": {
      "category": {
        "required": "Category is required"
      },
      "location": {
        "required": "Storage location is required"
      },
      "type": {
        "required": "Booking type is required"
      },
      "quantity": {
        "required": "Quantity is required",
        "min": "The given quantity must be greater then 0",
        "quantityMustBeInteger": "Quantity must be a whole number",
        "quantityExceedsStock": "Quantity exceeds available stock"
      }
    }
  },
  "userManagement": {
    "title": "User management",
    "members": "Members",
    "invite": "Invite user",
    "inviteEmail": "Email address",
    "inviteButton": "Invite",
    "inviteSuccess": "Invitation has been sent.",
    "pendingInvitations": "Pending invitations",
    "pendingStatus": "Pending",
    "removeUser": "Remove user",
    "removeConfirm": "Should this user really be removed?",
    "revokeInvitation": "Revoke invitation",
    "changeRole": "Change role",
    "roleChanged": "Role has been changed.",
    "noMembers": "No members available.",
    "roleAdministrator": "System Admin"
  },
  "notFound": {
    "message": "The requested page does not exist.",
    "title": "Page not found"
  },
  "poi": {
    "addImage": "Add image",
    "clickToAddMarker": "Click to add marker",
    "compressing": "Compressing image…",
    "confirmMarker": "Confirm marker",
    "imageAlt": "Point of interest",
    "imageLabel": "Image",
    "markerPlaceholder": "e.g. 100 m",
    "noImages": "No images available.",
    "removeImage": "Remove image",
    "removeMarker": "Remove marker",
    "showMarkerDetails": "Show marker details",
    "title": "Points of interest",
    "uploading": "Uploading image…"
  },
  "profile": {
    "changePassword": "Change password",
    "confirmPassword": "Confirm password",
    "deleteAccount": "Delete account",
    "deleteAccountWarning": "Warning: Deleting your account is irreversible. All your data will be permanently removed.",
    "displayName": "Display name",
    "email": "Email",
    "firstName": "First name",
    "lastName": "Last name",
    "newPassword": "New password",
    "passwordChanged": "Password has been changed",
    "personalData": "Personal data",
    "saved": "Profile saved",
    "title": "Account information"
  },
  "signupConfirmation": {
    "title": "Confirm email"
  },
  "snackbar": {
    "connectionIssue": "The request could not be completed. You may have no or a slow internet connection."
  },
  "success": {
    "accountDeleted": "Account has been deleted.",
    "emailVerificationSent": "Verification email has been sent.",
    "passwordUpdated": "Password has been updated.",
    "profileSaved": "Profile has been saved."
  },
  "tasks": {
    "add": "Create task",
    "confirmDelete": "Really delete this task?",
    "delete": "Delete task",
    "edit": "Edit task",
    "fields": {
      "addPhoto": "Add photo",
      "archived": "Archived",
      "assignees": "Assignees",
      "color": "Color",
      "description": "Description",
      "done": "Done",
      "photos": "Photos",
      "priority": "Priority",
      "requirements": "Requirements",
      "title": "Title"
    },
    "filter": {
      "archived": "Archived",
      "done": "Done",
      "open": "Open"
    },
    "markdown": {
      "edit": "Edit",
      "empty": "_No description_",
      "preview": "Preview"
    },
    "markUnread": "Mark as unread",
    "noColor": "No color",
    "noTasks": "No tasks",
    "priority": {
      "high": "High",
      "icon": {
        "label": "Priority: {{level}}"
      },
      "low": "Low",
      "medium": "Medium"
    },
    "title": "Tasks",
    "viewImage": "View image"
  },
  "validation": {
    "emailInvalid": "Please enter a valid email address.",
    "minLength": "At least {{count}} characters",
    "passwordMismatch": "Passwords do not match.",
    "passwordStrength": "Min. 8 characters with uppercase, lowercase, digit and special character."
  },
  "feed": {
    "actions": {
      "newGame": "logged a harvest entry",
      "updateGame": "updated a harvest entry",
      "newTask": "created a task",
      "updateTask": "updated a task",
      "taskStatusChange": "completed a task",
      "taskReopened": "reopened a task",
      "mapUpdate": "updated the map",
      "mapMarkerCreate": "added a marker",
      "mapMarkerUpdate": "updated a marker",
      "mapMarkerDelete": "removed a marker",
      "mapPolygonCreate": "added a polygon",
      "mapPolygonUpdate": "updated a polygon",
      "mapPolygonDelete": "removed a polygon",
      "releaseNotification": "New version available",
      "hideCreate": "created a hide",
      "hideUpdate": "updated a hide",
      "hideDelete": "deleted a hide"
    },
    "fields": {
      "title": "Title",
      "description": "Description",
      "requirements": "Requirements",
      "priority": "Priority",
      "archived": "Archived",
      "color": "Color",
      "species": "Species",
      "sex": "Sex",
      "age": "Age",
      "date": "Date",
      "hunter": "Hunter",
      "location": "Location",
      "sample": "Sample",
      "time": "Time",
      "comment": "Comment",
      "name": "Name",
      "type": "Type",
      "hideRef": "Hide",
      "fill": "Fill",
      "coordinates": "Coordinates",
      "tagIds": "Tags"
    },
    "values": {
      "true": "Yes",
      "false": "No"
    },
    "changesSummary": "{{count}} changes",
    "valueChanged": "{{field}} changed",
    "expand": "Show details",
    "collapse": "Hide details",
    "time": {
      "justNow": "Just now",
      "minutesAgo": "{{count}} min ago",
      "hoursAgo": "{{count}} h ago",
      "daysAgo": "{{count}} days ago"
    }
  },
  "stockFeed": {
    "actions": {
      "addition": "added stock",
      "removal": "removed stock",
      "reservation": "created a reservation",
      "fulfilled": "fulfilled a reservation",
      "cancelled": "cancelled a reservation"
    },
    "quantity": "{{delta}}"
  },
  "weather": {
    "selectEntry": "Select this hour's forecast"
  },
  "releaseNotes": {
    "title": "What's new",
    "historyTitle": "What's new",
    "version": "Version {{version}}",
    "gotIt": "Got it",
    "empty": "No news yet.",
    "types": {
      "feature": "New",
      "improvement": "Improved",
      "fix": "Fixed"
    }
  }
}
